import { AppFormItem, AppFormItemProps, AppInput } from 'components/atoms';
import { formFields } from 'consts/form/formFields';
import { createFieldValidationRules } from 'utils/formValidationHelpers';

export const FirstNameInputElement = (props: AppFormItemProps) => (
    <AppFormItem
        label="Imię"
        name={formFields.firstName}
        rules={createFieldValidationRules('firstName', {
            required: true,
            maxLength: 300,
        })}
        accessibilityLabel="Pole imię"
        {...props}
    >
        <AppInput
            autoComplete="given-name"
            accessibilityLabel="Pole imię"
            placeholder="Podaj imię"
        />
    </AppFormItem>
);
